import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/* eslint-disable max-len */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import Button from '../iconButton';
import { strings, cssClasses } from '@douyinfe/semi-foundation/lib/es/banner/constants';
import BannerFoundation from '@douyinfe/semi-foundation/lib/es/banner/foundation';
import '@douyinfe/semi-foundation/lib/es/banner/banner.css';
import Typography from '../typography';
import { IconClose, IconAlertTriangle, IconInfoCircle, IconTickCircle, IconAlertCircle } from '@douyinfe/semi-icons';
import warning from '@douyinfe/semi-foundation/lib/es/utils/warning';
import BaseComponent from '../_base/baseComponent';
const prefixCls = cssClasses.PREFIX;
const types = strings.TYPE;
export default class Banner extends BaseComponent {
  constructor(props) {
    super(props);

    this.remove = e => {
      e && e.stopPropagation();
      this.foundation.removeBanner(e);
    };

    this.state = {
      visible: true
    };
    warning('target' in this.props, '[Semi Banner] \'target\' has been deprecated, please write JSX directly instead.');
  }

  get adapter() {
    return _Object$assign(_Object$assign({}, super.adapter), {
      setVisible: () => {
        this.setState({
          visible: false
        });
      },
      notifyClose: e => {
        const {
          onClose
        } = this.props;
        onClose(e);
      }
    });
  }

  componentDidMount() {
    this.foundation = new BannerFoundation(this.adapter);
    this.foundation.init();
  }

  componentWillUnmount() {
    this.foundation.destroy();
  }

  renderCloser() {
    const {
      closeIcon
    } = this.props;

    if (closeIcon === null) {
      return closeIcon;
    }

    const closer = /*#__PURE__*/React.createElement(Button, {
      className: "".concat(prefixCls, "-close"),
      onClick: this.remove,
      icon: closeIcon || /*#__PURE__*/React.createElement(IconClose, null),
      theme: "borderless",
      size: "small",
      type: "tertiary"
    });
    return closer;
  }

  renderIcon() {
    const {
      type,
      icon
    } = this.props;
    const iconMap = {
      warning: /*#__PURE__*/React.createElement(IconAlertTriangle, {
        size: "large"
      }),
      success: /*#__PURE__*/React.createElement(IconTickCircle, {
        size: "large"
      }),
      info: /*#__PURE__*/React.createElement(IconInfoCircle, {
        size: "large"
      }),
      danger: /*#__PURE__*/React.createElement(IconAlertCircle, {
        size: "large"
      })
    };
    let iconType = iconMap[type];
    const iconCls = cls({
      ["".concat(prefixCls, "-icon")]: true // [prefixCls + '-' + type]: true,

    });

    if (typeof icon !== 'undefined') {
      iconType = icon;
    }

    if (iconType) {
      return /*#__PURE__*/React.createElement("div", {
        className: iconCls
      }, iconType);
    }

    return null;
  }

  render() {
    var _context;

    const {
      children,
      type,
      className,
      style,
      bordered,
      title,
      description,
      fullMode
    } = this.props;
    const {
      visible
    } = this.state;
    const wrapper = cls(prefixCls, className, {
      [_concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, type)]: type,
      ["".concat(prefixCls, "-full")]: fullMode,
      ["".concat(prefixCls, "-in-container")]: !fullMode,
      ["".concat(prefixCls, "-bordered")]: !fullMode && bordered
    });
    const banner = visible ? /*#__PURE__*/React.createElement("div", {
      className: wrapper,
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content-wrapper")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, this.renderIcon(), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content-body")
    }, title ? /*#__PURE__*/React.createElement(Typography.Title, {
      heading: 5,
      className: "".concat(prefixCls, "-title"),
      component: "div"
    }, title) : null, description ? /*#__PURE__*/React.createElement(Typography.Paragraph, {
      className: "".concat(prefixCls, "-description"),
      component: "div"
    }, description) : null)), this.renderCloser()), children ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-extra")
    }, children) : null) : null;
    return banner;
  }

}
Banner.propTypes = {
  // target: PropTypes.func,
  fullMode: PropTypes.bool,
  // insertAfter: PropTypes.func,
  type: PropTypes.oneOf(types),
  title: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  closeIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  onClose: PropTypes.func,
  bordered: PropTypes.bool
};
Banner.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose: () => {},
  type: 'info',
  fullMode: true
};